var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 13.0394C12.2568 13.0394 13.6 11.6963 13.6 10.0394C13.6 8.38257 12.2568 7.03943 10.6 7.03943C8.94312 7.03943 7.59998 8.38257 7.59998 10.0394C7.59998 11.6963 8.94312 13.0394 10.6 13.0394Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.599976 10.9194V9.15943C0.599976 8.11943 1.44998 7.25943 2.49998 7.25943C4.30998 7.25943 5.04998 5.97943 4.13998 4.40943C3.61998 3.50943 3.92998 2.33943 4.83998 1.81943L6.56998 0.829426C7.35998 0.359426 8.37998 0.639426 8.84998 1.42943L8.95998 1.61943C9.85998 3.18943 11.34 3.18943 12.25 1.61943L12.36 1.42943C12.83 0.639426 13.85 0.359426 14.64 0.829426L16.37 1.81943C17.28 2.33943 17.59 3.50943 17.07 4.40943C16.16 5.97943 16.9 7.25943 18.71 7.25943C19.75 7.25943 20.61 8.10943 20.61 9.15943V10.9194C20.61 11.9594 19.76 12.8194 18.71 12.8194C16.9 12.8194 16.16 14.0994 17.07 15.6694C17.59 16.5794 17.28 17.7394 16.37 18.2594L14.64 19.2494C13.85 19.7194 12.83 19.4394 12.36 18.6494L12.25 18.4594C11.35 16.8894 9.86998 16.8894 8.95998 18.4594L8.84998 18.6494C8.37998 19.4394 7.35998 19.7194 6.56998 19.2494L4.83998 18.2594C3.92998 17.7394 3.61998 16.5694 4.13998 15.6694C5.04998 14.0994 4.30998 12.8194 2.49998 12.8194C1.44998 12.8194 0.599976 11.9594 0.599976 10.9194Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings_icon.e36198aa1b7497446b1437cd0289c9bf.svg";
export { ForwardRef as ReactComponent };